import { Routes } from '@angular/router';
import { ApplicationGuard } from './modules/usermgmt/guards/application.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'digital-library', pathMatch: 'full' },
  {
    path: 'home',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'Home' },
    loadComponent: () => import('./features/dashboard/dashboard').then(m => m.Dashboard),
  },
  {
    path: 'digital-library',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'Home' },
    loadComponent: () => import('./features/digital-library/digital-library').then(m => m.DigitalLibrary)
  },
  {
    path: 'station-data',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'Home' },
    loadComponent: () => import('./features/digital-library/components/station-data/station-data').then(m => m.StationData)
  },
  {
    path: 'station-data/:code',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'Home' },
    loadComponent: () => import('./features/digital-library/components/station-data/station-data').then(m => m.StationData)
  },
  {
    path: 'assets-validation',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'Home' },
    loadComponent: () => import('./features/digital-library/components/assets-validation/assets-validation').then(m => m.AssetsValidation)
  },
  {
    path: 'sip-validation',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'Home' },
    loadComponent: () => import('./features/digital-library/components/sip-validation/sip-validation').then(m => m.SipValidation)
  },
  {
    path: 'assets-data',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'Home' },
    loadComponent: () => import('./features/digital-library/components/assets-data/assets-data').then(m => m.AssetsData)
  },
  {
    path: 'assets-viewer',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'Home' },
    loadComponent: () => import('./features/digital-library/components/asset-viewer/asset-viewer').then(m => m.AssetViewer)
  },
  {
    path: 'editor',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'Home' },
    loadComponent: () => import('./features/editor/editor.component').then(m => m.EditorComponent)
  },
  {
    path: 'usermgmt',
    canActivate: [ApplicationGuard],
    canDeactivate: [unsavedChangesGuard],
    data: { resource: 'User Management' },
    loadChildren: () =>
      import('usermgmt').then((m) => m.userMgmtRoutes)
  },
  { path: '**', redirectTo: 'digital-library' },
];
